import './App.css';
import Navbar from './Components/Navbar/Navbar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Shop from './Pages/Shop';
import ShopCategory from './Pages/ShopCategory';
import Product from './Pages/Product';
import Cart from './Pages/Cart';
import LoginSignup from './Pages/LoginSignup';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import Footer from './Components/Footer/Footer';
import Thor from './Components/Thor/Thor';
import MusicPlayer from './Components/MusicPlayer/MusicPlayer';
import Reviews from './Pages/Reviews';

function App() {
  return (
    <div>
      <BrowserRouter>
      <Navbar/>
      <Routes>
        <Route path='/' element={<Shop/>}/>
        <Route path='/valorant-vp' element={<ShopCategory category='vp'/>}/>
<Route path='/valorant-accounts' element={<ShopCategory category='accounts'/>}/>
        <Route path='product' element={<Product/>}>
        <Route path=':productId' element={<Product/>}/>
        </Route>
        <Route path='/cart' element={<Cart/>}/>
        <Route path='/login' element={<LoginSignup/>}/>
        <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
        <Route path='/reviews' element={<Reviews/>}/>
      </Routes>
      <Footer/>
      <Thor/>
      <MusicPlayer/> 
      </BrowserRouter>
    </div>
  );
}

export default App;
